import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, Mail, MapPin } from 'lucide-react';

const OVYC_LOGO = "https://customer-assets.emergentagent.com/job_b04ed63f-4684-4945-95bf-d34ff5934b34/artifacts/82m2edfj_updatred%20ovyc%20logo%20non%20transparent.png";

// TikTok icon component (not in lucide-react)
const TikTok = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const footerLinks = {
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'About OVYC', path: '/about' },
    { name: 'Partner With Us', path: '/partner' },
    { name: 'Impact', path: '/impact' },
    { name: 'Impact Reports', path: '/reports' },
    { name: 'Contact', path: '/contact' },
  ],
  social: [
    { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/ourvillage' },
    { name: 'Twitter', icon: Twitter, url: 'https://www.x.com/OVYourcommunity' },
    { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/in/our-village-your-community/' },
    { name: 'TikTok', icon: TikTok, url: 'https://www.tiktok.com/@ourvillageyc' },
  ],
};

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#264653] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img 
              src={OVYC_LOGO} 
              alt="OVYC" 
              className="h-14 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-white/80 text-base leading-relaxed max-w-md mb-6">
              Rebuilding community through safe spaces, creative projects and meaningful partnerships. 
              Creating and delivering community-led events, youth-focused opportunities and brand-supported 
              initiatives that bring people together.
            </p>
            <div className="flex items-center gap-2 text-white/70">
              <MapPin className="w-4 h-4" />
              <span className="text-sm">London, United Kingdom</span>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Manrope']">Navigation</h4>
            <nav className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  className="block text-white/70 hover:text-[#E3B505] transition-colors text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Manrope']">Get In Touch</h4>
            <div className="space-y-4">
              <a 
                href="mailto:hello@ovyc.co.uk"
                data-testid="footer-email"
                className="flex items-center gap-3 text-white/70 hover:text-[#E3B505] transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span className="text-sm">hello@ovyc.co.uk</span>
              </a>
              
              <div className="pt-4">
                <p className="text-sm text-white/50 mb-4">Follow us</p>
                <div className="flex items-center gap-4">
                  {footerLinks.social.map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`footer-social-${social.name.toLowerCase()}`}
                      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E3B505] hover:text-[#2D2A26] transition-all duration-300"
                      aria-label={social.name}
                    >
                      <social.icon className="w-5 h-5" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-center">
          <p className="text-white/50 text-sm">
            © 2026 Our Village, Your Community. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
